import React, { useState, useEffect } from "react";
import "./index.css";
import Itenary from "./Itenary";
import { useHistory } from "react-router-dom";
import Modal from "./../../../../../Component/Containers/Modal";
import FlightRules from "./FlightRules";
import { post } from "../../../../../Model/Config/Axios";
import { showToast } from "../../../../../Component/Toast";
import { useEventsHook } from "../../../../../Hooks/useEventsHook";
import Loader from "../../../../../Component/Loader";


function Index({ selected, passengers, onCancel }) {
  const [fareRuleModel, setFareRuleModel] = useState(false);
  const [Rules, SetRules] = useState(undefined);
  const [ReviewData, setReviewData] = useState(undefined);
  const [Failed, setFailed] = useState(false);
  let EVENTS = useEventsHook();

  let HISTORY = useHistory();
  let adultFare =
    selected && selected.fare.adult ? selected.fare.adult.publishedFare : 0;
  let childFare =
    selected && selected.fare.child ? selected.fare.child.publishedFare : 0;
  let infantFare =
    selected && selected.fare.infant ? selected.fare.infant.publishedFare : 0;

  let adultTotal = passengers.adult * adultFare;
  let childTotal = passengers.child * childFare;
  let infantTotal = passengers.infant * infantFare;

  let Total = adultTotal + childTotal + infantTotal;

  useEffect(() => {
    if (selected) {
      fetchReview();
    }
  }, [selected]);

  const fetchReview = () => {
    post(
      `/flight/domestic/review`,
      { fareId: selected.fare.key, inventoryId: selected.flight.key },
      (e, r) => {
        if (r.errors) {
          setFailed(r.errors[0].message);
        } else if (r) {
          setReviewData(r);

          //Check Price Change

          fetchRules();
          EVENTS.review({
            origin: r.search.origin.code || "BLANK",
            destination: r.search.destination.code || "BLANK",
            passengers:
              r.search.count.adult +
                r.search.count.child +
                r.search.count.infant || "BLANK",
            totalFare: r.review.fare.publishedFare || 0,
          });
        } else if (e) {
          showToast({
            type: "error",
            message: e.data
              ? e.data.message
              : "Problem in fetching flight details, try again",
          });
        }
      }
    );
  };

  const fetchRules = () => {
    post(
      `/flight/domestic/rules`,
      { fareId: selected.fare.key, inventoryId: selected.flight.key },
      (e, r) => {
        if (r.errors) {
        } else if (r) {
          SetRules(r);
        } else if (e) {
        }
      }
    );
  };

  const startBooking = () => {
    HISTORY.push({
      pathname: `/flights/main/booking`,
      state: { departureFlight: selected, totalFare: Total },
    });
  };
  if (selected) {
    return (
      <>
        {fareRuleModel && (
          <Modal
            onClose={() => setFareRuleModel(false)}
            title="Flight  details"
            noButtons={true}
          >
            <div className="d-flex flex-wrap align-items-center text-small w-100 ">
              {Rules ? (
                <FlightRules Rules={Rules} departureFlight={selected} />
              ):(
                <Loader/>
              )}
            </div>
          </Modal>
        )}
        <div className="FadeUp-Effect info-pane shadow-lg d-flex justify-content-center align-items-center">
          <div className="container">
            <div className="row">
              {selected && (
                <div className={`mt-4 mb-md-4 col-12 col-md-8`}>
                  <Itenary {...selected} heading="Departure" />
                </div>
              )}
              <div className="col-12 col-md-4 mb-4 mt-4 ps-md-5 align-self-center">
                <div className="flex-fill d-flex d-md-block align-items-center" style={{justifyContent: "space-between", alignItems: 'center'}}>
                  <span className="text-small text-muted ms-2 d-none d-md-block">
                    All Passengers
                  </span>
                  <div className="d-flex align-items-center mb-md-1 ms-2">
                    <h6 className="m-0 d-flex align-items-center text-nowrap flex-nowrap">
                      {passengers?.adult ? (
                        <>
                          {passengers?.adult}{" "}
                          Adult, &nbsp;
                        </>
                      ) : (
                        <></>
                      )}
                      {passengers?.child ? (
                        <>
                          {passengers?.child}{" "}
                          Child, &nbsp;
                        </>
                      ) : (
                        <></>
                      )}
                      {passengers?.infant ? (
                        <>
                          {passengers.infant}{" "}
                          Infant
                        </>
                      ) : (
                        <></>
                      )}
                    </h6>
                  </div>
                  <span className="text-small text-muted ms-2 d-none d-md-block mt-2">
                    Estimated Total
                  </span>
                  <h3 className="m-0 ms-2">Rs. {Math.ceil(Total)}</h3>
                </div>
                <p
                 className="m-0 ms-2"
               style={{ fontSize: 14,
                  color: "gray", textDecoration: "underline", cursor: "pointer", width: 'fit-content'}}
                  onClick={() => {
                    setFareRuleModel(true);
                  }}
                >
                  View Details
                </p>
                <div className="action-container">
                <button
                    onClick={() => onCancel()}
                    className="btn btn-outline-dark btn-lg rounded-pill ps-4 pe-4 mt-3 text-truncate"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={startBooking}
                    className="btn btn-dark btn-lg rounded-pill ps-4 pe-4 me-3 mt-3 mt-md-3 text-truncate"
                  >
                    Book<i className="fas fa-arrow-right ms-2"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return <></>;
  }
}

export default Index;
